<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import { TweenMax as Tween, TimelineMax as Line, Power1 } from 'gsap'

export default {

  name: 'Dots',

  props: {
    items: {
      type: Array,
      required: true
    },

    current: {
      type: Number,
      required: true
    },

    inverted: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      animating: true
    }
  },

  computed:{

    secondSlide(){
      return this.$store.state.app.mainPageSecondSlide;
    }

  },

  methods: {
    enter (el, done) {
      const items = this.$refs.items
      const line = this.$refs.line

      const tl = new Line

      tl.fromTo(line, 0.5, {
        scaleX: 0
      }, {
        scaleX: 1,
        ease: Power1.easeOut,
        onStart: () => {
          Tween.set(line, { autoAlpha: 1 })
          this.animating = false
        }
      })

      tl.to(line, 0.5, {
        scaleX: 0,
        onStart: () => line.style.transformOrigin = 'right',
        onComplete: () => line.removeAttribute('style')
      })

      tl.staggerFrom(items, 0.5, {
        autoAlpha: 0,
        ease: Power1.easeOut,
        onComplete () {
          if (this.target) this.target.removeAttribute('style')
        }
      }, 0.05, '-=0.5', done)
    },

    leave (el, done) {
      const items = this.$refs.items.reverse()
      const line = this.$refs.line

      // wtf

      this.animating = true
      const active = el.querySelector('.list-item.is-active')

      if (active) {
        const dot = active.querySelector('.list-item__dot')
        const label = active.querySelector('.list-item__label')
        dot.style.transitionDelay = '0s'
        dot.style.transitionDuration = '0.25s'
        active.classList.remove('is-active')
        if (label) this.labelLeave(label, () => {})
      }

      // wtf end

      const tl = new Line()

      tl.fromTo(line, 0.5, {
        scaleX: 0
      }, {
        scaleX: 1,
        ease: Power1.easeOut,
        onStart: () => Tween.set(line, { autoAlpha: 1, transformOrigin: 'right' })
      })

      tl.to(line, 0.5, {
        scaleX: 0,
        onStart: () => Tween.set(line, { transformOrigin: 'left' }),
        onComplete: done
      })

      tl.set(items, {
        autoAlpha: 0
      }, '-=0.5')
    },

    labelEnter (el, done) {
      Tween.from(el, 0.5, {
        width: 0,
        autoAlpha: 0,
        delay: 1,
        paddingRight: 0,
        ease: Power1.easeOut,
        onComplete: function () {
          Tween.set('.list-item:not(.is-active) .list-item__label',{
            width:0,
            autoAlpha: 0,
            paddingRight: 0
          });
        }
      })
    },

    labelLeave (el, done) {
      const duration = this.animating ? 0.25 : 0.5
      const delay = this.animating ? 0 : 0.5

      Tween.to(el, duration, {
        width: 0,
        delay,
        autoAlpha: 0,
        paddingRight: 0,
        ease: Power1.easeOut
      })
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.dot-nav(:class="{ 'is-inverted': inverted }")
  .list
    .list-line(ref="line")
    .list-item(
      v-for="item, index in items",
      ref="items",
      :class="{ 'is-active': index === current && !animating}")
      span.list-item__dot(:class="{ 'has-label': item.label }")
      transition(@enter="labelEnter" @leave="labelLeave")
        .list-item__label(v-if="item.label && index === current && !animating"): span {{ item.label }}

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.dot-nav
  display flex
  justify-content center
  width 200px
  height 78px

  +mobile()
    height: 20px

  &__content
    display flex
    justify-content center

.list
  display flex
  width auto

.list-line
  z-index 5
  position absolute
  top 0
  bottom 0
  left 0
  margin auto 0
  width 100%
  height 5px
  background-color orange
  transform-origin left
  opacity 0
  visibility hidden

.list-item
  flex 0 0 auto
  display flex
  align-items center
  // width 5px
  // height 5px
  color white
  padding-left 10px

  &__dot
    flex 0 0 auto
    display inline-flex
    width 5px
    height 5px
    margin-right 10px
    background-color white
    transition-property width, background-color, margin-right
    transition-duration 0.5s
    transition-delay 0

    .is-inverted &
      background-color blue

    &.has-label
      transition-delay 0.5s

    .is-active &
      width 15px
      background-color orange
      transition width 0.5s, background-color 0.5s, margin-right 0.5s

      &.has-label
        margin-right 18px
        transition width 0.5s 1s, background-color 0.5s 1s, margin-right 0.5s 1s

    .is-animating &
      transition-delay 0 !important

  &__label
    flex 0 0 auto
    font-size 14px
    font-weight 500
    line-height 78px
    padding-right 10px
    white-space nowrap
    overflow hidden

    .is-inverted &
      color: blue;

</style>



// WEBPACK FOOTER //
// dots.vue?02552d3a